import * as types from './mutation-types'

export default {
  [types.SET_PHOTOS] (state, obj) {
    state.photos = obj
  },
  [types.SET_PHOTO] (state, obj) {
    state.photo = obj
  }
}
